import { mapGetters, mapActions } from 'vuex'
import journal from '@/api/journal'
import { discountDetail } from '@/api/discount'

import SiteSearchGroup from '@/components/search-group'
import { DISCOUNT_STATUS } from '@/utils/dict'
import help from '@/utils/help'

import { getUploadConfig } from '@/utils/upload'

const columns = [
  {
    title: '',
    enTitle: 'Discount Code',
    width: 120,
    dataIndex: 'code',
    slot: 'code'
  },
  {
    title: '',
    enTitle: 'Voucher Value',
    width: 80,
    dataIndex: 'discount',
    slot: 'discount',
    sort: true
  },
  {
    title: '',
    enTitle: 'For Reviewer',
    width: 230,
    dataIndex: 'from',
    slot: 'fromR'
  },
  {
    title: '',
    enTitle: 'From Manuscript',
    width: 100,
    dataIndex: 'from',
    slot: 'fromM'
  },
  {
    title: '',
    enTitle: 'Discount User',
    width: 230,
    dataIndex: 'used',
    slot: 'fromR'
  },
  {
    title: '',
    enTitle: 'Used Manuscript',
    width: 100,
    dataIndex: 'used',
    slot: 'fromM'
  },
  {
    title: '',
    enTitle: 'Created Editor',
    width: 230,
    dataIndex: 'editor',
    slot: 'fromR'
  },
  {
    title: '',
    enTitle: 'Created Date',
    width: 120,
    dataIndex: 'grantTime',
    slot: 'date',
    sort: true
  },
  {
    title: '',
    enTitle: 'Expired Date',
    width: 120,
    dataIndex: 'expiredTime',
    slot: 'date',
    sort: true
  },
  {
    title: '',
    enTitle: 'Status',
    width: 100,
    dataIndex: 'status',
    slot: 'status'
  }
]
export default {
  components: {
    SiteSearchGroup
  },
  data() {
    return {
      columns,
      DISCOUNT_STATUS,
      journalList: [],
      dataSource: [],
      showAdv: false,
      params: {
        keyword: '',
        emailOrName: '',
        fromJournalId: '',
        usedJournalId: '',
        grantTimeStart: null,
        grantTimeEnd: null,
        expiredTimeStart: null,
        expiredTimeEnd: null,
        status: '',
        sorted: ''
      },
      grantDate: [],
      expiredDate: [],
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      }
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      user: 'getUser'
    })
  },
  async mounted() {
    await this.getJournalList()
    help.closeAutocomplete()
  },
  methods: {
    ...mapActions(['updateLoading']),
    async getList(page = 1) {
      if (this.params.expiredTimeStart && !this.params.expiredTimeEnd) {
        this.params.expiredTimeEnd = this.$moment()
      }
      if (this.params.grantTimeStart && !this.params.grantTimeEnd) {
        this.params.grantTimeEnd = this.$moment()
      }
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size
      })

      this.updateLoading(true)
      const { list, pageIndex, pageSize, total } = await discountDetail.get(
        data
      )
      this.dataSource = list

      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })

      this.updateLoading(false)
    },

    async grantDateChange(date) {
      this.params.grantTimeStart = date[0] ? date[0].startOf('d') : ''
      this.params.grantTimeEnd = date[1] ? date[1].endOf('d') : ''
      this.getList()
    },
    async expiredDateChange(date) {
      this.params.expiredTimeStart = date[0] ? date[0].startOf('d') : ''
      this.params.expiredTimeEnd = date[1] ? date[1].endOf('d') : ''
      this.getList()
    },

    async getJournalList() {
      this.journalList = await journal.userGet({ released: true })
      this.journalList.unshift({
        name: 'All',
        journalId: '',
        id: ''
      })
      const flag = this.journalList.some(item => {
        if (item.id === localStorage.getItem('journalId')) {
          this.params.journalId = item.id
          return true
        }
      })
      if (!flag) {
        this.params.journalId = this.journalList[0] && this.journalList[0].id
        localStorage.setItem('journalId', this.params.journalId)
      }

      this.changeJournal(this.params.journalId)
    },

    handleClear() {
      this.params.keyword = ''
      this.params.emailOrName = ''
      this.params.fromJournalId = ''
      this.params.usedJournalId = ''
      this.params.grantTimeStart = null
      this.params.grantTimeEnd = null
      this.params.submittedDate = null
      this.params.expiredTimeStart = null
      this.params.expiredTimeEnd = null
      this.params.status = ''
      this.grantDate = []
      this.expiredDate = []
      this.getList()
    },
    changeJournal(val) {
      this.getList()
      localStorage.setItem('journalId', val)
    },

    copyCode(val) {
      help.copyToBlock(val)
      this.$message.success({
        title: 'Success',
        content: 'The Manuscript No. has been copied to the clipboard!'
      })
    },

    changeStatus(val) {
      this.params.searchStatus = val
      this.getList()
    },

    async exp() {
      const res = await discountDetail.export(this.params)
      help.download(res.url, res.fileName)
    },
    openPerson(record) {
      help.openWindow(
        `/user-manage/manage-users/${record.id}/personal-information`
      )
    },
    onOrderChanage(val) {
      this.params.sorted = val
      this.getList()
    }
  }
}
